import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    fontFamily: 'Inter',
    color: 'white',
    marginTop:'25px',
    display: 'flex',
    flexDirection:'column',
    marginLeft: 0,
    width: '100%'
  },

}));

export default useStyles;
